// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1k56d","content":"LoadingAlert_content__2V70M"};